import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
import { Button } from '@checkmarx/cx-ui';
import AddLdapGroupMappingDialog from './addLdapGroupMappingDialog';
import ErrorDialog from '../../portal/dialogs/errorDialog';
import { sort } from '../../../services/utils';
@inject('translationsStore', 'rootLdapStore', 
    'groupMapping', 'ldapTeamMappingStore', 'teamsStore') @observer
export default class AddLdapGroupMappingDialogContainer extends Component {
    
    rootLdapStore = this.props.rootLdapStore;
    groupMapping = this.props.groupMapping;

    state = {
        openDialog: false,
        openErrorDialog: false
    }

    openAddDialog = () => {

        this.setState({ 
            openDialog: true
        });
    }

    closeAddDialog = (e) => {

        this.setState({ 
            openDialog: false
        });
    }

    openErrorDialog = () => {

        this.setState({ 
            openErrorDialog: true
        }); 
    }

    closeErrorDialog = () => {

        this.setState({ 
            openErrorDialog: false
        }); 
    }
    
    resetForm = () => {

        this.groupMapping.resetForm();
        this.groupMapping.resetEntries();
        this.groupMapping.setGroupEntriesOptimized(undefined);
    }

    resetFormAndCloseAddDialog = () => {

        this.resetForm();
        this.closeAddDialog();
    }

    importGroups = () => {

        this.props.ldapTeamMappingStore.getByServerId(this.groupMapping.selectedServerId)
            .then((servers) => {

                servers.forEach(item => {
                    
                    this.props.groupMapping.appnedEntryId({
                        teamId: item.teamId,
                        ldapGroupDn: item.ldapGroupDn,
                        ldapGroupDisplayName: item.ldapGroupDisplayName
                    });
                });

                const finalList = this.groupMapping.getNormalizedEntries(this.groupMapping.mappedGruopModel);
                
                this.props.ldapTeamMappingStore.put(this.groupMapping.selectedServerId, finalList)
                    .then(() => {

                        this.resetFormAndCloseAddDialog();
                        this.props.ldapTeamMappingStore.getByTeamId(this.props.teamsStore.selectedTeamId);
                    })
                    .catch(() => {

                        this.openErrorDialog();
                    });

        });
    }

    ldapServersChange = (e, index, value) => {

        this.resetForm();
        this.groupMapping.setSelectedServerId(value);
    }

    buildGroupEntries = () => {

        let entries = [];

        if (this.groupMapping.groupEntries === undefined
                || this.groupMapping.groupEntries.length === 0) {
            
            this.groupMapping.setGroupEntriesOptimized(entries);
            
            return;
        }

        this.groupMapping.groupEntries.forEach(item => {

            let imported = false;

            if (this.props.ldapTeamMappingStore.ldapTeamMappings) {
             
                const result = this.props.ldapTeamMappingStore.ldapTeamMappings
                                    .filter((i) => item.dn === i.ldapGroupDn 
                                                        && i.ldapServerId === this.groupMapping.selectedServerId);
                imported = result.length > 0;
            }

            entries.push({
                id: item.dn,
                name: item.name,
                group: item.dn,
                ldapGroupDisplayName: item.dn,
                teamId: this.props.teamsStore.selectedTeamId,
                selected: false,
                imported: imported
            });
        });

        this.groupMapping.setGroupEntriesOptimized(entries);
    }

    search = (e) => {

        e.preventDefault();

        if (this.groupMapping.nameContainsPattern == '') {
            
            return;
        }

        this.groupMapping.resetEntries();
        this.groupMapping.resetMappedGruopModel();
        this.groupMapping.resetGroupEntriesOptimized();

        this.groupMapping.searchGroupEntries(this.groupMapping.selectedServerId, this.groupMapping.nameContainsPattern)
            .then(() => {
                
                this.buildGroupEntries();
                
            })
            .catch(() => {

                this.setState({
                    openErrorDialog: true
                });
            });
    }

    searchBoxChange = (e) => {

        this.groupMapping.setNameContainsPattern(e.target.value);
    }

    componentDidMount() {
        
        this.rootLdapStore.getLDAPServers()
            .then(() => {

                let ldapServers = [];

                const temp = this.rootLdapStore.visibleLdapServersForMapping();

                temp.forEach(s => {
                    
                    ldapServers.push({
                        id: s.id,
                        name: s.name
                    });
                });
                
                if (ldapServers.length > 0) {
                 
                    ldapServers = sort(ldapServers)('name')('asc');
                    this.groupMapping.setSelectedServerId(ldapServers[0].id);
                    this.groupMapping.setLdapServers(ldapServers);
                }
            });
    }

    render() {

        if (this.rootLdapStore.ldapServers === undefined) {
            
            return null;
        }

        const ldapServers = this.groupMapping.ldapServers;

        const title = <span>{this.props.translationsStore.translate('ERROR')}</span>;
        
        const dialogTranslations = {
            directory: this.props.translationsStore.translate('DIRECTORY'),
            cancel: this.props.translationsStore.translate('CANCEL'),
            import: this.props.translationsStore.translate('IMPORT'),
            addGroups: this.props.translationsStore.translate('ADD_LDAP_GROUPS'),
            searchLdapGroups: this.props.translationsStore.translate('SEARCH_LDAP_GROUP'),
            selectLdapDirectoryGroupMapping: this.props.translationsStore.translate('SELECT_LDAP_DIRECTORY_GROUP_MAPPING')
        };

        return (
            <div>
                <Button
                    onClick={this.openAddDialog}
                    text={this.props.translationsStore.translate('ADD_LDAP_GROUP_MAPPING')}
                >
                </Button>
                <AddLdapGroupMappingDialog 
                    open={this.state.openDialog}
                    translations={dialogTranslations}
                    closeDialog={this.resetFormAndCloseAddDialog}
                    openDialog={this.openAddDialog}
                    importGroups={this.importGroups}
                    ldapServers={ldapServers}
                    ldapServersChange={this.ldapServersChange}
                    selectedItem={this.groupMapping.selectedServerId}
                    search={this.search}
                    searchValue={this.groupMapping.nameContainsPattern}
                    onChange={this.searchBoxChange}
                    selectedEntries={this.groupMapping.selectedEntries}
                    importInProgress={this.props.ldapTeamMappingStore.putLdapTeamMappingsProgress}
                />
                <ErrorDialog 
                    show={this.state.openErrorDialog}
                    onConfirm={this.closeErrorDialog}
                    deleteButtonText={this.props.translationsStore.translate('CLOSE')}
                    closeDeleteDialog={this.closeErrorDialog}
                    titleText={title}
                    contentText={this.groupMapping.getLDAPGroupEntriesErrorMessage}
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/teams/addLdapGroupMappingDialogContainer/index.jsx